import React from 'react';
import {t} from "../../../components/Translate";

const SearchAndFilter = ({ searchQuery, handleSearchChange, resourceTypeFilter, setResourceTypeFilter, currentUser }) => (
    <div className="resources-search-export-container">
        <input
            type="text"
            placeholder={t(currentUser.language, "searchKeysOrTranslations")}
            value={searchQuery}
            onChange={handleSearchChange}
            className="resources-search-input"
        />
        <div className="resource-type-filter" aria-label="Resource type filter">
            <button
                type="button"
                className={`resource-type-option ${resourceTypeFilter === 'all' ? 'active' : ''}`}
                onClick={() => setResourceTypeFilter('all')}
            >
                All
            </button>
            <button
                type="button"
                className={`resource-type-option ${resourceTypeFilter === 'text' ? 'active' : ''}`}
                onClick={() => setResourceTypeFilter('text')}
            >
                Text
            </button>
            <button
                type="button"
                className={`resource-type-option ${resourceTypeFilter === 'html' ? 'active' : ''}`}
                onClick={() => setResourceTypeFilter('html')}
            >
                Html
            </button>
        </div>
    </div>
);

export default SearchAndFilter;
